import { Injectable } from "@angular/core";
import { All, AppActionTypes } from "@app/store/actions/app.actions";
import { InitializeAppSuccess } from "@app/store/actions/initialize-app.actions";
import { setTimeagoIntl } from "@app/translate-loader";
import { CommonApiService } from "@core/services/api/classic/common/common-api.service";
import { JsonApiService } from "@core/services/api/classic/json/json-api.service";
import { WindowRefService } from "@core/services/window-ref.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie";
import { TimeagoIntl } from "ngx-timeago";
import { forkJoin, Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

@Injectable()
export class InitializeAppEffects {
  InitializeApp: Observable<InitializeAppSuccess> = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActionTypes.INITIALIZE),
      switchMap(() => {
        const language =
          this.cookieService.get("astrobin_lang") || this.windowRefService.nativeWindow.navigator.language || "en";

        const subscriptions$ = this.commonApiService.getSubscriptions().pipe(catchError(() => of([])));
        const language$ = of(language);
        const backendConfig$ = this.jsonApiService.getBackendConfig();
        const requestCountry$ = this.jsonApiService.requestCountry();

        return forkJoin([
          language$,
          subscriptions$,
          backendConfig$,
          requestCountry$,
          this.translateService.use(language)
        ]).pipe(
          map(results => {
            this.translateService.setDefaultLang(language);
            setTimeagoIntl(this.timeagoIntl, language);
            return new InitializeAppSuccess({
              language: results[0],
              subscriptions: results[1],
              backendConfig: results[2],
              requestCountry: results[3]
            });
          })
        );
      })
    )
  );

  constructor(
    public readonly actions$: Actions<All>,
    public readonly commonApiService: CommonApiService,
    public readonly jsonApiService: JsonApiService,
    public readonly translateService: TranslateService,
    public readonly timeagoIntl: TimeagoIntl,
    public readonly windowRefService: WindowRefService,
    public readonly cookieService: CookieService
  ) {}
}
